import { useState, useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "@/pages/home/components/Header";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

interface NewsLink {
  label: string;
  url: string;
}

interface NewsItem {
  id: string;
  date: string;
  title: string;
  body: string;
  linkUrl?: string;
  linkLabel?: string;
  links?: NewsLink[];
  expandableSections?: { title: string; content: string }[];
}

const newsData: NewsItem[] = [
  {
    id: "changes-to-the-board",
    date: "NOV 2025",
    title: "Changements au conseil de fiduciaires",
    body: "La Caisse de retraite des musiciens du Canada souhaite annoncer officiellement le départ à la retraite du fiduciaire employeur et vice-président, Eddy Bayens, du conseil de fiduciaires. M. Bayens a servi les membres de la Caisse avec dévouement pendant plus de 20 ans. Au cours de cette période, il a contribué à guider la Caisse à travers de multiples crises économiques tout en renforçant la santé financière du régime. Son leadership, son esprit de collaboration et sa sagesse nous manqueront grandement. La Caisse de retraite des musiciens du Canada et ses membres remercient M. Bayens pour ses décennies de service fidèle.\n\nM. Bayens sera remplacé au poste de vice-président par Bernard LeBlanc. M. LeBlanc siège au conseil de fiduciaires de la Caisse de retraite des musiciens du Canada depuis 10 ans. Il a suivi toute la formation appropriée de l'IFEBP et ces connaissances, combinées à ses années d'expérience, ont fait de lui le candidat idéal pour ce poste. Il a été nommé à l'unanimité au poste de vice-président par les autres fiduciaires.\n\nLa Caisse de retraite des musiciens du Canada souhaite également la bienvenue à David Owen au conseil de fiduciaires. Les fiduciaires ont nommé M. Owen au poste de fiduciaire employé laissé vacant par M. Bayens. M. Owen joue du hautbois ainsi que du cor anglais. Il a été membre du Vancouver Opera Orchestra, du Turning Point Ensemble et du Canadian Chamber Orchestra. Il est également un avocat pleinement formé qui a pratiqué le droit tout en poursuivant sa carrière d'interprète. Il a été nommé secrétaire de la Vancouver Musicians Association en 2011. Il a déménagé à Halifax en 2021, où il a été nommé président de l'Atlantic Federation of Musicians, section locale 571. M. Owen s'est engagé à respecter la mission de la Caisse, qui est d'administrer le régime de manière prudente afin d'assurer sa viabilité à long terme dans le but d'offrir les meilleures prestations de retraite possible aux membres et aux bénéficiaires de la Caisse.",
  },
  {
    id: "passing-of-jill-giustino",
    date: "JAN 2025",
    title: "Annonce du décès de Jill Giustino, directrice générale",
    body: "Lisez l'annonce officielle de la Caisse de retraite des musiciens du Canada.",
    linkUrl: "/wp-content/uploads/nl-202501/English.html",
    linkLabel: "Lire l'annonce",
  },
  {
    id: "extension-to-recent-plan-amendment",
    date: "JAN 2021",
    title: "Prolongation d'une modification récente du régime",
    body: "Lisez l'avis officiel concernant la prolongation de la récente modification du régime.",
    linkUrl: "/wp-content/uploads/nl-202101/English.html",
    linkLabel: "Lire l'avis",
  },
  {
    id: "covid-19-pandemic",
    date: "AVR 2020",
    title: "Pandémie de COVID-19 et volatilité des marchés financiers",
    body: "Lisez la mise à jour officielle de la Caisse sur la COVID-19 et les questions et réponses connexes.",
    links: [
      { label: "Lire la mise à jour", url: "/wp-content/uploads/nl-202004-Covid/2020-04-CovidFin-web/english.html" },
      { label: "Lire les Q et R", url: "/wp-content/uploads/nl-202004-Covid/2020-04-Covid19QA-web/english.html" },
    ],
  },
  {
    id: "feb-2019-announcement",
    date: "FÉV 2019",
    title: "Annonce",
    body: "Lisez l'annonce officielle de 2019 de la Caisse de retraite des musiciens du Canada.",
    linkUrl: "/wp-content/uploads/2019/02/Announcement-2019.pdf",
    linkLabel: "Lire l'annonce",
  },
  {
    id: "may-2017-intl-musicians-article",
    date: "MAI 2017",
    title: "Avis important concernant l'article de mai 2017 de l'International Musician",
    body: "Lisez l'avis important concernant l'article de mai 2017 de l'International Musician.",
    linkUrl: "/wp-content/uploads/2017/05/FR-Important-Notice-re-Article-by-Ray-Hair-2017.pdf",
    linkLabel: "Lire l'avis",
  },
  {
    id: "jun-2016-announcement",
    date: "JUIN 2016",
    title: "Annonce",
    body: "Lisez l'annonce officielle de juin 2016 de la Caisse de retraite des musiciens du Canada.",
    linkUrl: "/wp-content/uploads/2016/06/Announce20160627en.pdf",
    linkLabel: "Lire l'annonce",
  },
  {
    id: "feb-2016-quebec-bill-34",
    date: "FÉV 2016",
    title: "Mise à jour sur le projet de loi 34 du Québec",
    body: "Lisez la mise à jour de février 2016 concernant le projet de loi 34 du Québec.",
    linkUrl: "/wp-content/uploads/2016/03/Flyer20160306_en.pdf",
    linkLabel: "Lire la mise à jour",
  },
  {
    id: "nov-2015-quebec-bill-34",
    date: "NOV 2015",
    title: "Mise à jour sur le projet de loi 34 du Québec",
    body: "Lisez la mise à jour de novembre 2015 concernant le projet de loi 34 du Québec.",
    linkUrl: "/wp-content/uploads/2016/03/Bill_34_English",
    linkLabel: "Lire la mise à jour",
  },
  {
    id: "may-2014-gmmq-referendum",
    date: "MAI 2014",
    title: "Référendum de la GMMQ / Section locale 406 CFM/AFM sur la désaffiliation",
    body: "Les fiduciaires de la Caisse de retraite des musiciens du Canada ont été informés que la Guilde des musiciens et musiciennes du Québec (GMMQ) tenait un référendum du 2 au 8 juin 2014 sur sa désaffiliation de l'AFM.\n\nOn a demandé aux fiduciaires si les membres de la GMMQ pourraient continuer à participer au régime de retraite et si les prestations accumulées et les pensions des membres du Québec seraient protégées si le vote menait à la désaffiliation. Une série de réunions des fiduciaires a eu lieu au cours desquelles ces questions ont été pleinement examinées.",
    linkUrl: "/wp-content/uploads/2016/03/Trustee-Letter-GMMQ-Referendum-English.pdf",
    linkLabel: "Lire la réponse",
  },
  {
    id: "jan-2014-2013-results-strong",
    date: "JAN 2014",
    title: "Bons résultats en 2013; les défis de la Caisse se poursuivent",
    body: "La nouvelle année a suscité de nombreux appels et courriels au Bureau de la Caisse de la part de membres désireux de savoir si 2013 avait été une bonne année pour le régime. Plutôt que de répondre à chaque appel individuellement, nous avons décidé qu'il serait préférable de publier une communication à tous les membres afin que chacun dispose exactement des mêmes renseignements.\n\n2013 a été une bonne année pour les placements du régime. Nous avons obtenu un rendement de 18 % au cours de l'année et la valeur de nos actifs au 31 décembre a atteint 675 M$.",
    linkUrl: "/wp-content/uploads/2016/03/January-2014-English.pdf",
    linkLabel: "Lire la suite",
  },
  {
    id: "jan-2013-faq-benefit-changes",
    date: "JAN 2013",
    title: "FAQ Questions sur les modifications des prestations 2013",
    body: "1. Pourquoi avons-nous été prévenus si peu de temps avant ces modifications du régime?\n\nCe n'était certainement pas le choix de la Caisse. Nous ne pouvions faire aucune annonce avant que la Commission des services financiers de l'Ontario (CSFO, l'organisme de réglementation) n'approuve à la fois la modification et notre matériel de communication.",
    linkUrl: "/wp-content/uploads/2016/03/FAQ-Questions-Benefit-Changes-2013.pdf",
    linkLabel: "Lire la suite",
  },
  {
    id: "dec-2012-notice-of-plan-changes",
    date: "DÉC 2012",
    title: "Avis de modifications du régime de la Caisse de retraite des musiciens du Canada",
    body: "Nous souhaitons vous informer de certaines modifications du régime qui entreront en vigueur le 1er janvier 2013 afin de nous conformer aux récentes modifications des exigences provinciales de financement.\n\nComment ces modifications m'affecteront-elles?\n\nCes modifications ne touchent que les cotisations futures.",
    links: [
      { label: "Lire l'avis", url: "/wp-content/uploads/2016/03/Notice-of-Plan-Changes-December-2012.pdf" },
      { label: "Lire les renseignements généraux", url: "/wp-content/uploads/2016/03/Background-Information-December-2012.pdf" },
    ],
  },
  {
    id: "dec-2012-notice-to-pensioners",
    date: "DÉC 2012",
    title: "Avis aux retraités",
    body: "Chers retraités et bénéficiaires :\n\nNous souhaitons vous informer que certaines modifications du régime entreront en vigueur le 1er janvier 2013.",
    linkUrl: "/wp-content/uploads/2016/03/Notice-to-Pensioners-December-2012.pdf",
    linkLabel: "Lire la suite",
  },
  {
    id: "mar-2012-kinross-class-action",
    date: "MAR 2012",
    title: "Recours collectif Kinross – Résumé de l'action",
    body: "Les fiduciaires de la Caisse de retraite des musiciens du Canada sont les demandeurs dans un recours collectif d'actionnaires intenté le 12 mars 2012 devant la Cour supérieure de justice de l'Ontario contre Kinross Gold Corporation et plusieurs membres de sa haute direction.",
    linkUrl: "/wp-content/uploads/2012/03/Summary-of-Kinross-Class-Action-March-15-2012.pdf",
    linkLabel: "Lire la suite",
  },
  {
    id: "oct-2010-plan-changes",
    date: "OCT 2010",
    title: "Modifications du régime",
    body: "Des modifications du régime entreront en vigueur le 1er janvier 2011. Veuillez consulter le bulletin d'automne 2010 pour plus de détails.",
    linkUrl: "/wp-content/uploads/2015/15/InConcert-Fall-2010.pdf",
    linkLabel: "Voir le bulletin",
  },
  {
    id: "jan-2009-somepp-election-notice",
    date: "JAN 2009",
    title: "Avis d'élection SOMEPP",
    body: "Nous souhaitons vous informer que les fiduciaires ont déposé une élection auprès du surintendant de la Commission des services financiers de l'Ontario (CSFO) pour que l'American Federation of Musicians' and Employers' Pension Welfare Fund (Canada) soit désigné comme un régime de retraite interentreprises déterminé de l'Ontario (SOMEPP).",
    expandableSections: [
      {
        title: "Lire l'avis complet d'élection SOMEPP",
        content: "Qu'est-ce qu'un SOMEPP?\n\nNotre régime est déjà reconnu comme un régime de retraite interentreprises (RRI) en vertu de la Loi sur les prestations de retraite de l'Ontario. La désignation SOMEPP est une nouvelle catégorie de RRI conçue pour offrir un allégement temporaire des exigences actuelles de financement de solvabilité pendant que la province élabore une solution plus permanente pour le financement de solvabilité.\n\nÉvaluation actuarielle du 1er janvier 2008\n\nUne évaluation actuarielle du régime a été réalisée au 1er janvier 2008. Elle a montré que le régime est plus que entièrement capitalisé sur une base de « continuité d'exploitation ». Cela signifie qu'au 1er janvier 2008, les actifs du régime couvrent plus que les coûts des prestations accumulées, en supposant que le régime continue de fonctionner indéfiniment.\n\nEn vertu de la loi sur les pensions, l'actuaire doit également effectuer une évaluation de solvabilité sur une base de « liquidation » au 1er janvier 2008. Cette évaluation suppose que le régime cesse de fonctionner, liquide tous ses placements et verse toutes les prestations à la date d'évaluation. Selon cette mesure, les actifs du régime couvriraient 92 % des coûts des prestations. Veuillez noter que cette situation est purement hypothétique — en réalité, le régime n'a pas été liquidé. Au contraire, nous nous attendons à ce qu'il continue de fonctionner pendant de nombreuses années, comme il l'a fait depuis plus de 40 ans.\n\nAllégement temporaire du financement de solvabilité\n\nNormalement, la province exigerait des mesures pour combler le déficit de solvabilité, et pour un RRI comme le nôtre, cela pourrait entraîner des réductions de prestations. Cependant, avec la désignation SOMEPP, le régime n'aura pas à combler le déficit de solvabilité pendant trois ans (2008-2010). Cette exemption de trois ans n'aura aucune incidence sur votre prestation de retraite, sauf dans le cas très improbable où le régime prendrait fin et où les actifs ne suffiraient pas à financer toutes les prestations accumulées à ce moment-là. Dans ce cas très improbable, les prestations devraient être réduites.",
      },
      {
        title: "Lire les renseignements généraux",
        content: "Qu'est-ce qu'une évaluation?\n\nC'est un bilan de santé financier du régime de retraite. En tant que régime de retraite agréé offrant des prestations déterminées, notre régime doit déposer une évaluation auprès de l'autorité des pensions de l'Ontario au moins tous les trois ans. Les évaluations sont effectuées par des actuaires, des professionnels indépendants possédant une expertise particulière dans ce domaine. Ils utilisent des méthodes et des hypothèses communément acceptées pour évaluer si les actifs du régime sont suffisants pour honorer ses obligations de paiement des prestations, maintenant et à l'avenir. Ils tiennent compte de renseignements déjà connus avec certitude (p. ex., l'âge des membres et les prestations accumulées, la formule de prestations du régime, les actifs de la Caisse et les taux de cotisation actuels des employeurs). Ils font également des hypothèses conservatrices à très long terme sur ce qui se passera dans l'avenir (p. ex., à quel âge les membres prendront-ils leur retraite? combien de temps vivront-ils après leur retraite? quel revenu de placement la Caisse gagnera-t-elle, en moyenne, pendant que les membres accumulent et reçoivent leurs prestations?)\n\nQu'est-ce qu'une évaluation de continuité d'exploitation?\n\nCe type d'évaluation suppose que le régime de retraite continuera de fonctionner indéfiniment. Elle adopte une perspective à long terme, reconnaissant que les prestations de retraite sont généralement accumulées, financées et versées sur de nombreuses années. Par exemple, un membre peut accumuler des prestations pendant 30 à 40 ans et recevoir une pension pendant plus de 25 ans. De même, les actifs du régime devraient bénéficier de nombreuses années pour s'accumuler et générer des revenus de placement. Sur cette base, les fluctuations à court terme des résultats de placement ne sont pas très importantes — c'est le taux de rendement global à long terme qui compte.\n\nQu'est-ce qu'une évaluation de liquidation/solvabilité?\n\nUne évaluation de solvabilité examine ce qui arriverait si le régime était liquidé immédiatement. Elle adopte une approche à court terme et mesure le niveau de sécurité des prestations si un régime est soudainement résilié (p. ex., si l'employeur annule le régime ou cesse ses activités). Cela pourrait être une préoccupation réelle pour un régime à employeur unique, mais c'est moins probable dans un régime de retraite interentreprises comme le nôtre où de nombreux employeurs sont impliqués et les taux de cotisation sont établis dans des ententes négociées.\n\nDevrions-nous nous inquiéter du déficit?\n\nIl n'est pas inhabituel que les régimes de retraite aient un déficit de solvabilité. En fait, plus de 3 régimes de retraite sur 4 qui ont déposé des évaluations en Ontario entre juillet 2004 et juin 2007 ont déclaré des ratios inférieurs à 1,00, et environ la moitié étaient inférieurs à 0,90. Avec un ratio de solvabilité de 0,92 au 1/1/08, notre régime est en fait plus sain que beaucoup d'autres. L'évaluation de solvabilité n'est qu'une mesure de la santé financière d'un régime de retraite et ne correspond pas réellement à la situation d'un régime de retraite interentreprises. La réalité est que notre régime n'a pas pris fin le 1er janvier 2008. Au contraire, il devrait continuer à fonctionner pendant de nombreuses autres années.\n\nQuelle est la santé de notre régime?\n\nSur la base de l'évaluation de continuité d'exploitation, notre régime est entièrement capitalisé au 1/1/08 et dispose en fait d'un certain excédent d'actifs. Bien entendu, ces résultats ne reflètent pas les baisses des marchés des derniers mois. Néanmoins, l'excédent d'actifs offre une marge de manœuvre qui aide à atténuer l'impact des baisses récentes. Notre Caisse de retraite est investie à long terme, ce qui joue en notre faveur. Elle est diversifiée parmi diverses catégories d'actifs et conçue pour résister aux fluctuations à court terme du marché. Au cours des 40 dernières années, la Caisse a traversé de nombreux cycles de volatilité des marchés.\n\nQue se passe-t-il après trois ans?\n\nL'Ontario a introduit la désignation SOMEPP de façon temporaire pendant qu'elle continue d'examiner les questions de financement. Cela s'est produit après que de nombreux fiduciaires de RRI et leurs conseillers, confrontés à des préoccupations croissantes concernant le financement de solvabilité, ont demandé à la province de revoir les règles. Ils ont souligné que les normes habituelles ne correspondaient pas à la situation des régimes interentreprises — d'autant plus que les RRI sont moins susceptibles d'être résiliés soudainement. Nous espérons que la province introduira des modifications permanentes des exigences de financement dans un proche avenir qui seront plus adaptées aux régimes comme le nôtre. À mesure que nous avançons, les fiduciaires continueront de surveiller de près la santé financière du régime dans le but de protéger la santé et la sécurité de la Caisse de retraite pour de nombreuses années à venir.",
      },
    ],
  },
  {
    id: "oct-2008-volatility-in-stock-markets",
    date: "OCT 2008",
    title: "Volatilité des marchés boursiers",
    body: "Notre Caisse, comme de nombreuses caisses de retraite, a connu de nombreux « hauts et bas » sur les marchés depuis sa création. À l'heure actuelle, les marchés semblent particulièrement volatils, mais l'histoire nous apprend que ce type de volatilité ne dure pas éternellement. Sachez que nous suivons la situation de près. Et rappelez-vous que nous sommes là « pour le long terme ».\n\nChaque fois que nous envisageons d'apporter des modifications, nous le faisons dans une optique de santé et de sécurité à long terme de la promesse de retraite de la Caisse. Nous continuerons de surveiller l'évolution des événements locaux et mondiaux et de consulter nos conseillers au besoin. Nous vous tiendrons informés s'il y a un impact important à long terme sur la Caisse.\n\nVeuillez garder à l'esprit que la Caisse est une Caisse de retraite à prestations déterminées — ceci est expliqué dans notre section FAQ (n° 1 et 7).",
  },
  {
    id: "dec-2007-disability-pension-notice",
    date: "DÉC 2007",
    title: "Avis concernant la prestation d'invalidité",
    body: "Les membres du régime qui demandent une prestation d'invalidité à compter du 1er janvier 2008 ne seront pas admissibles à recevoir une prestation d'invalidité s'ils sont admissibles à recevoir des prestations d'invalidité de leur employeur ou en vertu d'un programme d'assurance offert par leur employeur. Les retraités qui reçoivent une prestation d'invalidité au 31 décembre 2007 ne sont pas touchés par cette règle. Veuillez communiquer avec le Bureau de la Caisse si vous avez besoin de plus amples renseignements.",
  },
  {
    id: "aug-2007-trustee-update",
    date: "AOÛT 2007",
    title: "Mise à jour des fiduciaires",
    body: "Le fiduciaire employé Bobby Herriot, après de nombreuses années de service dévoué à la Fédération (y compris son mandat de fiduciaire de la Caisse), a annoncé sa retraite à compter du 31 juillet 2007. Nous remercions Bobby pour son service à la Caisse et adressons nos meilleurs vœux à Bobby et à Etta pour une retraite longue, heureuse et en bonne santé. Nous souhaitons la bienvenue à Bill Skolnik, vice-président nouvellement élu du Canada, AFM, au poste de fiduciaire employé.",
  },
  {
    id: "feb-2007-notice-to-pensioners",
    date: "FÉV 2007",
    title: "Avis aux retraités",
    body: "En réponse aux demandes de renseignements concernant une augmentation pour 2007, nous vous informons qu'il n'y a aucun changement aux pensions en cours de versement pour le moment. Bien que les fiduciaires aient, à de nombreuses reprises dans le passé, accordé des augmentations ponctuelles aux pensions en cours de versement, les règles du régime ne prévoient aucune augmentation automatique (c.-à-d. des augmentations du coût de la vie). La Caisse demeure financièrement saine et les fiduciaires envisageront à nouveau d'autres augmentations ponctuelles à l'avenir.",
  },
  {
    id: "dec-2006-new-employee-trustee",
    date: "DÉC 2006",
    title: "Nouveau fiduciaire employé",
    body: "Le Fonds AFM-EPW (Canada) est heureux d'accueillir notre nouveau fiduciaire employé, Charles Barbeau. M. Barbeau est le vice-président de la Guilde des musiciens du Québec.",
  },
];

export default function FrNews() {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultId = "changes-to-the-board";

  const getInitialId = (): string => {
    const article = searchParams.get("article");
    if (article && newsData.some((n) => n.id === article)) return article;
    return defaultId;
  };

  const [selectedId, setSelectedId] = useState(getInitialId);
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});
  const { t } = useTranslation();
  const selectedItem = newsData.find((n) => n.id === selectedId) ?? newsData[0];

  const handleSelect = useCallback((id: string) => {
    setSelectedId(id);
    setSearchParams({ article: id }, { replace: true });
  }, [setSearchParams]);

  const toggleSection = useCallback((sectionKey: string) => {
    setExpandedSections((prev) => ({ ...prev, [sectionKey]: !prev[sectionKey] }));
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Navbar />

      <main className="flex-1">
        <section className="w-full bg-[#0d1f4c] py-10">
          <div className="max-w-[1200px] mx-auto px-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-0.5 bg-[#1a8fc1]"></div>
              <span className="text-[#7ec8e3] text-xs font-semibold tracking-widest uppercase">
                {t("news.pageLabel")}
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
              {t("news.pageTitle")}
            </h1>
            <p className="text-base text-white/70 max-w-[560px]">
              {t("news.pageDesc")}
            </p>
          </div>
        </section>

        <div className="lg:hidden w-full bg-[#f4f8fc] border-b border-gray-100 py-4">
          <div className="max-w-[1200px] mx-auto px-6">
            <label htmlFor="news-select" className="sr-only">{t("news.selectNews")}</label>
            <select
              id="news-select"
              value={selectedId}
              onChange={(e) => handleSelect(e.target.value)}
              className="w-full text-sm font-medium text-[#0d1f4c] bg-white border border-gray-200 rounded-lg px-4 py-3 appearance-none cursor-pointer focus:outline-none focus:border-[#1a8fc1] focus:ring-2 focus:ring-[#1a8fc1]/20"
              style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%230d1f4c' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 12px center",
                paddingRight: "40px",
              }}
            >
              {newsData.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.date} — {item.title}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="w-full bg-white">
          <div className="max-w-[1200px] mx-auto px-6 py-8">
            <div className="flex flex-col lg:flex-row border border-gray-100 rounded-lg overflow-hidden bg-white">
              <aside className="hidden lg:flex flex-col w-[320px] flex-shrink-0 border-r border-gray-100 bg-[#fafcfe] lg:h-[620px]">
                <div className="px-6 py-4 border-b border-gray-100">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-widest">
                    {t("news.archive")}
                  </h3>
                </div>
                <nav className="flex-1 overflow-y-auto py-1 [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-thumb]:bg-gray-200/80 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-transparent">
                  {newsData.map((item) => {
                    const isActive = item.id === selectedId;
                    return (
                      <button
                        key={item.id}
                        onClick={() => handleSelect(item.id)}
                        className={`w-full flex items-start gap-3 px-6 py-2.5 text-left transition-all duration-200 cursor-pointer ${
                          isActive
                            ? "bg-[#e8f2f9] border-l-2 border-[#1a8fc1]"
                            : "border-l-2 border-transparent hover:bg-[#f4f8fb]"
                        }`}
                      >
                        <div className="flex-1 min-w-0">
                          <span className={`block text-[10px] font-semibold tracking-wide uppercase mb-0.5 ${
                            isActive ? "text-[#1a8fc1]" : "text-gray-400"
                          }`}>
                            {item.date}
                          </span>
                          <span className={`block text-[13px] leading-snug ${
                            isActive ? "text-[#0d1f4c] font-semibold" : "text-gray-600 font-normal"
                          }`}>
                            {item.title}
                          </span>
                        </div>
                        {isActive && (
                          <span className="mt-1.5 w-1.5 h-4 rounded-full bg-[#1a8fc1] flex-shrink-0"></span>
                        )}
                      </button>
                    );
                  })}
                </nav>
              </aside>

              <div className="flex-1 min-w-0 bg-[#fafbfd]">
                <div className="p-6 lg:p-8">
                  <div className="lg:hidden mb-4">
                    <span className="inline-block text-xs font-semibold text-[#1a8fc1] tracking-widest uppercase bg-[#f4f8fc] px-3 py-1 rounded-full mb-3">
                      {selectedItem.date}
                    </span>
                  </div>
                  <span className="hidden lg:inline-block text-xs font-semibold text-[#1a8fc1] tracking-widest uppercase bg-[#f4f8fc] px-3 py-1 rounded-full mb-4">
                    {selectedItem.date}
                  </span>
                  <h2 className="text-xl md:text-2xl font-bold text-[#0d1f4c] mb-4 leading-tight">
                    {selectedItem.title}
                  </h2>
                  <div className="w-10 h-0.5 bg-[#1a8fc1] mb-5"></div>
                  <div className="text-sm text-gray-500 leading-relaxed max-w-[740px]">
                    {selectedItem.body.split("\n\n").map((para, i) => (
                      <p key={i} className={i > 0 ? "mt-3" : ""}>{para}</p>
                    ))}
                  </div>

                  {selectedItem.expandableSections && selectedItem.expandableSections.length > 0 && (
                    <div className="flex flex-col gap-2 mt-5">
                      {selectedItem.expandableSections.map((section, i) => {
                        const sectionKey = `${selectedItem.id}-section-${i}`;
                        const isExpanded = expandedSections[sectionKey] === true;
                        return (
                          <div key={sectionKey}>
                            <button
                              onClick={() => toggleSection(sectionKey)}
                              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1a8fc1] border border-[#1a8fc1]/40 rounded-lg px-4 py-2.5 hover:bg-[#f4f8fc] hover:border-[#1a8fc1] transition-colors cursor-pointer whitespace-nowrap"
                            >
                              {section.title}
                              <i className={`${isExpanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-sm transition-transform`}></i>
                            </button>
                            {isExpanded && (
                              <div className="mt-3 ml-1 pl-4 border-l-2 border-[#1a8fc1]/30 text-sm text-gray-500 leading-relaxed max-w-[740px]">
                                {section.content.split("\n\n").map((para, j) => (
                                  <p key={j} className={j > 0 ? "mt-3" : ""}>{para}</p>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {selectedItem.links && selectedItem.links.length > 0 ? (
                    <div className="flex flex-wrap gap-3 mt-5">
                      {selectedItem.links.map((link, i) => (
                        <a
                          key={i}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1a8fc1] border border-[#1a8fc1]/40 rounded-lg px-4 py-2.5 hover:bg-[#f4f8fc] hover:border-[#1a8fc1] transition-colors cursor-pointer whitespace-nowrap"
                        >
                          {link.label}
                          <i className="ri-arrow-right-up-line text-sm"></i>
                        </a>
                      ))}
                    </div>
                  ) : selectedItem.linkUrl && (
                    <a
                      href={selectedItem.linkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 mt-5 text-sm font-semibold text-[#1a8fc1] border border-[#1a8fc1]/40 rounded-lg px-4 py-2.5 hover:bg-[#f4f8fc] hover:border-[#1a8fc1] transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {selectedItem.linkLabel || "Lire"}
                      <i className="ri-arrow-right-up-line text-sm"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}